<div [formGroup]="campaignForm" class="has-validation">
  <label class="form-label">
    {{ 'field.state' | translate }}
  </label>
  <input type="text" class="form-control" id="state" formControlName="state"  [ngClass]="{ 'is-invalid': campaignForm.get('state')?.invalid}" />
  <div class="invalid-feedback" translate="field.required"></div>
</div>
